import * as React from 'react';

interface IUseSelectOutsideClickParams {
	isOpen: boolean;
	menuRef?: React.RefObject<HTMLElement>;
	onOutsideClick: (event: MouseEvent) => void;
	rootRef: React.RefObject<HTMLElement>;
}

const getElementFromEventTarget = (target: EventTarget | null): Element | null => {
	if (target instanceof Element) {
		return target;
	}
	if (target instanceof Node) {
		return target.parentElement;
	}
	return null;
};

const isInsideSelectRoot = (target: EventTarget | null, rootElement: HTMLElement | null): boolean => {
	const targetElement = getElementFromEventTarget(target);
	const labelElement = targetElement?.closest('label');
	const labelControl = labelElement instanceof HTMLLabelElement ? labelElement.control : null;
	return Boolean(
		rootElement &&
			targetElement &&
			(rootElement.contains(targetElement) || (labelControl && rootElement.contains(labelControl)))
	);
};

/**
 * Closes an open select when a pointer interaction occurs outside its root.
 */
export const useSelectOutsideClick = ({
	isOpen,
	menuRef,
	onOutsideClick,
	rootRef,
}: IUseSelectOutsideClickParams): void => {
	React.useEffect(() => {
		if (!isOpen) {
			return;
		}

		const handleMouseDown = (event: MouseEvent): void => {
			if (
				!isInsideSelectRoot(event.target, rootRef.current) &&
				!isInsideSelectRoot(event.target, menuRef?.current ?? null)
			) {
				onOutsideClick(event);
			}
		};

		document.addEventListener('mousedown', handleMouseDown);
		return () => document.removeEventListener('mousedown', handleMouseDown);
	}, [isOpen, menuRef, onOutsideClick, rootRef]);
};
